import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

const quickTags = ["心理惊悚", "文字冒险", "黑白漫画", "分级制度", "慢节奏"];

export default function SearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/news/all?q=${encodeURIComponent(value)}` : "/news");
  };

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-[1280px] flex-col gap-4 px-4 py-6 md:flex-row md:items-center md:gap-6 md:px-6 md:py-7">
        <div className="shrink-0">
          <p className="text-[10px] tracking-[0.2em] text-foreground-500">SEARCH THE ARCHIVE</p>
          <p className="mt-1 font-heading text-base font-semibold text-foreground-950">想找点什么？</p>
        </div>
        <form onSubmit={submit} role="search" className="flex w-full flex-col gap-2 sm:flex-row">
          <label className="relative flex flex-1 items-center">
            <i className="ri-search-line absolute left-3 text-sm text-foreground-400" aria-hidden="true"></i>
            <input
              type="search"
              name="q"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="输入作品名称、题材或关键词，例如「心理惊悚」"
              className="h-11 w-full rounded-md border border-background-300/70 bg-background-50 pl-9 pr-3 text-sm text-foreground-800 outline-none transition placeholder:text-foreground-400 focus:border-primary-400"
            />
          </label>
          <button
            type="submit"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-700"
          >
            搜索全站
          </button>
        </form>
        <div className="flex flex-wrap items-center gap-2 md:max-w-[240px]">
          {quickTags.slice(0, 3).map((tag) => (
            <Link
              key={tag}
              to={`/news/all?q=${encodeURIComponent(tag)}`}
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-300/80 bg-background-50 px-2.5 py-1 text-[11px] text-foreground-600 transition hover:border-accent-400 hover:text-accent-700"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}